<template>
  <div class="mt-2 flex gap-6">
    <div class="w-3xs">
      <div class="mb-3">
        <CreateScanAction />
      </div>
      <form
        ref="status_form"
        class="mb-4 space-y-4"
        @submit="submit_without_reloading"
        @reset="
          selected_statuses = [];
          keyword = '';
        "
      >
        <div class="space-y-2">
          <div>
            <legend>Đường dẫn</legend>
            <label class="input w-full">
              <i class="fa-solid fa-magnifying-glass text-base-content/80"></i>
              <input
                type="text"
                placeholder="Tìm kiếm theo đường dẫn"
                name="keyword"
                v-model="keyword"
                :disabled="actionHistoryQuery.isPending.value"
              />
            </label>
          </div>
          <div>
            <legend>Trạng thái</legend>
            <div class="flex flex-col flex-wrap gap-1">
              <input
                class="btn w-fit"
                type="checkbox"
                name="status"
                aria-label="Chờ xử lý"
                v-model="selected_statuses"
                value="pending"
                :disabled="actionHistoryQuery.isPending.value"
              />
              <input
                class="btn w-fit"
                type="checkbox"
                name="status"
                aria-label="Đang xử lý"
                v-model="selected_statuses"
                value="in-progress"
                :disabled="actionHistoryQuery.isPending.value"
              />
              <input
                class="btn w-fit"
                type="checkbox"
                name="status"
                aria-label="Đã hoàn thành"
                v-model="selected_statuses"
                value="complete"
                :disabled="actionHistoryQuery.isPending.value"
              />
            </div>
          </div>
        </div>
        <div class="flex flex-wrap gap-1">
          <input
            class="btn btn-outline grow"
            type="reset"
            value="&#8635; Đặt lại"
            :disabled="actionHistoryQuery.isPending.value"
          />
          <button
            class="btn btn-primary btn-outline grow"
            type="submit"
            :disabled="
              !filter_has_changed || actionHistoryQuery.isPending.value
            "
          >
            &#10003; Áp dụng
          </button>
        </div>
      </form>
    </div>

    <div class="grow">
      <div class="breadcrumbs text-sm">
        <ul>
          <li>
            <RouterLink
              :to="{
                name: 'ClientExplorer',
              }"
            >
              Explorer
            </RouterLink>
          </li>
          <li><a>Lịch sử quét</a></li>
        </ul>
      </div>
      <Loading v-if="actionHistoryQuery.isPending.value" />
      <div
        v-else-if="(actionHistoryQuery.data.value?.total_filter ?? 0) > 0"
        class="overflow-x-auto"
      >
        <table class="table-pin-rows table-md mb-4 table">
          <thead>
            <tr>
              <th>Đường dẫn</th>
              <th>Thời gian tạo</th>
              <th>Trạng thái</th>
            </tr>
          </thead>
          <tbody class="bg-base-200">
            <tr
              v-for="action in actionHistoryQuery.data.value?.data"
              :key="action.id"
            >
              <td>
                <RouterLink
                  :to="{
                    name: 'ClientExplorerScanHistoryDetail',
                    params: {
                      action_id: action.id,
                    },
                  }"
                >
                  {{ action.path }}
                </RouterLink>
              </td>
              <td>
                <div
                  class="tooltip"
                  :data-tip="
                    dayjs(action.created).format('YYYY-MM-DD HH:mm:ss')
                  "
                >
                  {{ dayjs(action.created).fromNow() }}
                </div>
              </td>
              <td>
                <ActionStatusBadge :status="action.status" />
              </td>
            </tr>
          </tbody>
        </table>
        <Pagination :total_pages="total_pages" />
      </div>
      <NotFound v-else />
    </div>
  </div>
</template>

<script setup lang="ts">
import { array_from_query, number_from_query, str_from_query } from "@/api";
import ActionStatusBadge from "@/components/ActionStatusBadge.vue";
import Loading from "@/components/LoadingTemplate.vue";
import NotFound from "@/components/NotFound.vue";
import Pagination from "@/components/PaginationTemplate.vue";
import { router } from "@/router/router";
import dayjs from "dayjs";
import { computed, ref } from "vue";
import type { action_str, type_str } from "..";
import CreateScanAction from "./CreateScanAction.vue";
import { useActionHistoryQuery } from "./useAction";

const init_keyword = computed(() =>
  String(router.currentRoute.value.query.keyword ?? ""),
);
const init_status = computed<string[]>(() =>
  array_from_query("status", String),
);

const keyword = ref<string>(init_keyword.value);
const selected_statuses = ref<string[]>(init_status.value);
const filter_has_changed = computed(
  () =>
    JSON.stringify(selected_statuses.value) !=
      JSON.stringify(init_status.value) || keyword.value !== init_keyword.value,
);

const params = computed(() => ({
  action: "scan" as action_str,
  type: "explore" as type_str,
  page: number_from_query("page", 1),
  size: number_from_query("size", 24),
  status: array_from_query("status", String),
  keyword: str_from_query("keyword"),
}));

const actionHistoryQuery = useActionHistoryQuery(params);

const total_pages = computed(() => {
  const total = actionHistoryQuery.data.value?.total_filter ?? 0;
  const size = number_from_query("size", 24);
  return Math.max(1, Math.ceil(total / size));
});

const submit_without_reloading = (e: Event) => {
  e.preventDefault();
  router.push({
    name: router.currentRoute.value.name,
    query: {
      ...router.currentRoute.value.query,
      page: 1,
      status: selected_statuses.value,
      keyword: keyword.value,
    },
  });
};
</script>
